import { Avatar } from '@mui/material';

import useCompanyImage from 'pages/CompanyData/components/CompanyImage/hooks/useCompanyImage';

const CompanyAvatar: React.FC<{ companyUuid?: string; alt?: string; size?: number }> = ({
  companyUuid = '',
  alt = '',
  size = 24,
}) => {
  const { companyImage } = useCompanyImage(companyUuid);

  return (
    <Avatar
      src={companyImage || undefined}
      alt={alt}
      sx={{ width: size, height: size, margin: 0, padding: 0 }}
    />
  );
};

export default CompanyAvatar;
